"use client";
import {
  createElement,
  createHook,
  forwardRef
} from "./ILRXHV7V.js";

// src/visually-hidden/visually-hidden.tsx
var TagName = "span";
var useVisuallyHidden = createHook(
  function useVisuallyHidden2(props) {
    props = {
      ...props,
      style: {
        border: 0,
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: 0,
        position: "absolute",
        whiteSpace: "nowrap",
        width: "1px",
        ...props.style
      }
    };
    return props;
  }
);
var VisuallyHidden = forwardRef(function VisuallyHidden2(props) {
  const htmlProps = useVisuallyHidden(props);
  return createElement(TagName, htmlProps);
});

export {
  useVisuallyHidden,
  VisuallyHidden
};
